// Protocol Buffers for Guardian Infrastructure License Management
// 
// Purpose: License generation, validation, and subscription management
// for Guardian AI Multi-Cloud Infrastructure product
//
// License Format: TIER.EXPIRY.UNIQUE_ID.ED25519_SIGNATURE

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/infra/infra_license.proto (package guardianai.v1.infra, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/infra/infra_license.proto.
 */
export const file_guardianai_v1_infra_infra_license: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty]);

/**
 * ============================================
 * LICENSE MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.infra.InfraLicense
 */
export type InfraLicense = Message<"guardianai.v1.infra.InfraLicense"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * TIER.EXPIRY.UNIQUE_ID.SIGNATURE
   *
   * @generated from field: string license_key = 2;
   */
  licenseKey: string;

  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 3;
   */
  tier: LicenseTier;

  /**
   * @generated from field: string customer_email = 4;
   */
  customerEmail: string;

  /**
   * @generated from field: string customer_name = 5;
   */
  customerName: string;

  /**
   * @generated from field: string stripe_subscription_id = 6;
   */
  stripeSubscriptionId: string;

  /**
   * @generated from field: string stripe_customer_id = 7;
   */
  stripeCustomerId: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp issued_at = 9;
   */
  issuedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 10;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp revoked_at = 11;
   */
  revokedAt?: Timestamp;

  /**
   * Usage limits based on tier
   *
   * @generated from field: int32 max_services = 12;
   */
  maxServices: number;

  /**
   * @generated from field: int32 max_environments = 13;
   */
  maxEnvironments: number;

  /**
   * @generated from field: bool ha_enabled = 14;
   */
  haEnabled: boolean;

  /**
   * @generated from field: bool priority_support = 15;
   */
  prioritySupport: boolean;
};

/**
 * ============================================
 * LICENSE MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.infra.InfraLicense
 */
export type InfraLicenseJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * TIER.EXPIRY.UNIQUE_ID.SIGNATURE
   *
   * @generated from field: string license_key = 2;
   */
  licenseKey?: string;

  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 3;
   */
  tier?: LicenseTierJson;

  /**
   * @generated from field: string customer_email = 4;
   */
  customerEmail?: string;

  /**
   * @generated from field: string customer_name = 5;
   */
  customerName?: string;

  /**
   * @generated from field: string stripe_subscription_id = 6;
   */
  stripeSubscriptionId?: string;

  /**
   * @generated from field: string stripe_customer_id = 7;
   */
  stripeCustomerId?: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp issued_at = 9;
   */
  issuedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 10;
   */
  expiresAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp revoked_at = 11;
   */
  revokedAt?: TimestampJson;

  /**
   * Usage limits based on tier
   *
   * @generated from field: int32 max_services = 12;
   */
  maxServices?: number;

  /**
   * @generated from field: int32 max_environments = 13;
   */
  maxEnvironments?: number;

  /**
   * @generated from field: bool ha_enabled = 14;
   */
  haEnabled?: boolean;

  /**
   * @generated from field: bool priority_support = 15;
   */
  prioritySupport?: boolean;
};

/**
 * Describes the message guardianai.v1.infra.InfraLicense.
 * Use `create(InfraLicenseSchema)` to create a new message.
 */
export const InfraLicenseSchema: GenMessage<InfraLicense, {jsonType: InfraLicenseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 0);

/**
 * @generated from message guardianai.v1.infra.GenerateLicenseRequest
 */
export type GenerateLicenseRequest = Message<"guardianai.v1.infra.GenerateLicenseRequest"> & {
  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 1;
   */
  tier: LicenseTier;

  /**
   * Default 365
   *
   * @generated from field: int32 validity_days = 2;
   */
  validityDays: number;

  /**
   * @generated from field: string customer_email = 3;
   */
  customerEmail: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: string stripe_subscription_id = 5;
   */
  stripeSubscriptionId: string;

  /**
   * @generated from field: string stripe_customer_id = 6;
   */
  stripeCustomerId: string;
};

/**
 * @generated from message guardianai.v1.infra.GenerateLicenseRequest
 */
export type GenerateLicenseRequestJson = {
  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 1;
   */
  tier?: LicenseTierJson;

  /**
   * Default 365
   *
   * @generated from field: int32 validity_days = 2;
   */
  validityDays?: number;

  /**
   * @generated from field: string customer_email = 3;
   */
  customerEmail?: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName?: string;

  /**
   * @generated from field: string stripe_subscription_id = 5;
   */
  stripeSubscriptionId?: string;

  /**
   * @generated from field: string stripe_customer_id = 6;
   */
  stripeCustomerId?: string;
};

/**
 * Describes the message guardianai.v1.infra.GenerateLicenseRequest.
 * Use `create(GenerateLicenseRequestSchema)` to create a new message.
 */
export const GenerateLicenseRequestSchema: GenMessage<GenerateLicenseRequest, {jsonType: GenerateLicenseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 1);

/**
 * @generated from message guardianai.v1.infra.LicenseResponse
 */
export type LicenseResponse = Message<"guardianai.v1.infra.LicenseResponse"> & {
  /**
   * @generated from field: guardianai.v1.infra.InfraLicense license = 1;
   */
  license?: InfraLicense;

  /**
   * "guardian auth login LICENSE_KEY"
   *
   * @generated from field: string activation_command = 2;
   */
  activationCommand: string;
};

/**
 * @generated from message guardianai.v1.infra.LicenseResponse
 */
export type LicenseResponseJson = {
  /**
   * @generated from field: guardianai.v1.infra.InfraLicense license = 1;
   */
  license?: InfraLicenseJson;

  /**
   * "guardian auth login LICENSE_KEY"
   *
   * @generated from field: string activation_command = 2;
   */
  activationCommand?: string;
};

/**
 * Describes the message guardianai.v1.infra.LicenseResponse.
 * Use `create(LicenseResponseSchema)` to create a new message.
 */
export const LicenseResponseSchema: GenMessage<LicenseResponse, {jsonType: LicenseResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 2);

/**
 * @generated from message guardianai.v1.infra.ValidateLicenseRequest
 */
export type ValidateLicenseRequest = Message<"guardianai.v1.infra.ValidateLicenseRequest"> & {
  /**
   * @generated from field: string license_key = 1;
   */
  licenseKey: string;
};

/**
 * @generated from message guardianai.v1.infra.ValidateLicenseRequest
 */
export type ValidateLicenseRequestJson = {
  /**
   * @generated from field: string license_key = 1;
   */
  licenseKey?: string;
};

/**
 * Describes the message guardianai.v1.infra.ValidateLicenseRequest.
 * Use `create(ValidateLicenseRequestSchema)` to create a new message.
 */
export const ValidateLicenseRequestSchema: GenMessage<ValidateLicenseRequest, {jsonType: ValidateLicenseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 3);

/**
 * @generated from message guardianai.v1.infra.ValidationResponse
 */
export type ValidationResponse = Message<"guardianai.v1.infra.ValidationResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 2;
   */
  tier: LicenseTier;

  /**
   * @generated from field: string customer_email = 3;
   */
  customerEmail: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;

  /**
   * If invalid, explains why
   *
   * @generated from field: string error_message = 5;
   */
  errorMessage: string;

  /**
   * Tier capabilities
   *
   * @generated from field: int32 max_services = 6;
   */
  maxServices: number;

  /**
   * @generated from field: int32 max_environments = 7;
   */
  maxEnvironments: number;

  /**
   * @generated from field: bool ha_enabled = 8;
   */
  haEnabled: boolean;

  /**
   * @generated from field: bool priority_support = 9;
   */
  prioritySupport: boolean;
};

/**
 * @generated from message guardianai.v1.infra.ValidationResponse
 */
export type ValidationResponseJson = {
  /**
   * @generated from field: bool valid = 1;
   */
  valid?: boolean;

  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 2;
   */
  tier?: LicenseTierJson;

  /**
   * @generated from field: string customer_email = 3;
   */
  customerEmail?: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: TimestampJson;

  /**
   * If invalid, explains why
   *
   * @generated from field: string error_message = 5;
   */
  errorMessage?: string;

  /**
   * Tier capabilities
   *
   * @generated from field: int32 max_services = 6;
   */
  maxServices?: number;

  /**
   * @generated from field: int32 max_environments = 7;
   */
  maxEnvironments?: number;

  /**
   * @generated from field: bool ha_enabled = 8;
   */
  haEnabled?: boolean;

  /**
   * @generated from field: bool priority_support = 9;
   */
  prioritySupport?: boolean;
};

/**
 * Describes the message guardianai.v1.infra.ValidationResponse.
 * Use `create(ValidationResponseSchema)` to create a new message.
 */
export const ValidationResponseSchema: GenMessage<ValidationResponse, {jsonType: ValidationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 4);

/**
 * @generated from message guardianai.v1.infra.GetLicenseRequest
 */
export type GetLicenseRequest = Message<"guardianai.v1.infra.GetLicenseRequest"> & {
  /**
   * @generated from oneof guardianai.v1.infra.GetLicenseRequest.identifier
   */
  identifier: {
    /**
     * @generated from field: string id = 1;
     */
    value: string;
    case: "id";
  } | {
    /**
     * @generated from field: string license_key = 2;
     */
    value: string;
    case: "licenseKey";
  } | {
    /**
     * @generated from field: string stripe_subscription_id = 3;
     */
    value: string;
    case: "stripeSubscriptionId";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message guardianai.v1.infra.GetLicenseRequest
 */
export type GetLicenseRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string license_key = 2;
   */
  licenseKey?: string;

  /**
   * @generated from field: string stripe_subscription_id = 3;
   */
  stripeSubscriptionId?: string;
};

/**
 * Describes the message guardianai.v1.infra.GetLicenseRequest.
 * Use `create(GetLicenseRequestSchema)` to create a new message.
 */
export const GetLicenseRequestSchema: GenMessage<GetLicenseRequest, {jsonType: GetLicenseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 5);

/**
 * @generated from message guardianai.v1.infra.ListLicensesRequest
 */
export type ListLicensesRequest = Message<"guardianai.v1.infra.ListLicensesRequest"> & {
  /**
   * Optional
   *
   * @generated from field: guardianai.v1.infra.LicenseTier tier_filter = 1;
   */
  tierFilter: LicenseTier;

  /**
   * Default true
   *
   * @generated from field: bool active_only = 2;
   */
  activeOnly: boolean;

  /**
   * Optional partial match
   *
   * @generated from field: string email_search = 3;
   */
  emailSearch: string;

  /**
   * Default 50
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 5;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.infra.ListLicensesRequest
 */
export type ListLicensesRequestJson = {
  /**
   * Optional
   *
   * @generated from field: guardianai.v1.infra.LicenseTier tier_filter = 1;
   */
  tierFilter?: LicenseTierJson;

  /**
   * Default true
   *
   * @generated from field: bool active_only = 2;
   */
  activeOnly?: boolean;

  /**
   * Optional partial match
   *
   * @generated from field: string email_search = 3;
   */
  emailSearch?: string;

  /**
   * Default 50
   *
   * @generated from field: int32 limit = 4;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 5;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.infra.ListLicensesRequest.
 * Use `create(ListLicensesRequestSchema)` to create a new message.
 */
export const ListLicensesRequestSchema: GenMessage<ListLicensesRequest, {jsonType: ListLicensesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 6);

/**
 * @generated from message guardianai.v1.infra.ListLicensesResponse
 */
export type ListLicensesResponse = Message<"guardianai.v1.infra.ListLicensesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.infra.InfraLicense licenses = 1;
   */
  licenses: InfraLicense[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.infra.ListLicensesResponse
 */
export type ListLicensesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.infra.InfraLicense licenses = 1;
   */
  licenses?: InfraLicenseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.infra.ListLicensesResponse.
 * Use `create(ListLicensesResponseSchema)` to create a new message.
 */
export const ListLicensesResponseSchema: GenMessage<ListLicensesResponse, {jsonType: ListLicensesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 7);

/**
 * @generated from message guardianai.v1.infra.RevokeLicenseRequest
 */
export type RevokeLicenseRequest = Message<"guardianai.v1.infra.RevokeLicenseRequest"> & {
  /**
   * @generated from field: string license_id = 1;
   */
  licenseId: string;

  /**
   * For audit log
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.infra.RevokeLicenseRequest
 */
export type RevokeLicenseRequestJson = {
  /**
   * @generated from field: string license_id = 1;
   */
  licenseId?: string;

  /**
   * For audit log
   *
   * @generated from field: string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.infra.RevokeLicenseRequest.
 * Use `create(RevokeLicenseRequestSchema)` to create a new message.
 */
export const RevokeLicenseRequestSchema: GenMessage<RevokeLicenseRequest, {jsonType: RevokeLicenseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 8);

/**
 * ============================================
 * SUBSCRIPTION STATS (Admin Dashboard)
 * ============================================
 *
 * @generated from message guardianai.v1.infra.SubscriptionStats
 */
export type SubscriptionStats = Message<"guardianai.v1.infra.SubscriptionStats"> & {
  /**
   * @generated from field: int32 total_subscribers = 1;
   */
  totalSubscribers: number;

  /**
   * @generated from field: int32 pro_subscribers = 2;
   */
  proSubscribers: number;

  /**
   * @generated from field: int32 enterprise_subscribers = 3;
   */
  enterpriseSubscribers: number;

  /**
   * @generated from field: int32 active_trials = 4;
   */
  activeTrials: number;

  /**
   * Revenue
   *
   * Monthly Recurring Revenue in cents
   *
   * @generated from field: int64 mrr_cents = 5;
   */
  mrrCents: bigint;

  /**
   * Annual Recurring Revenue in cents
   *
   * @generated from field: int64 arr_cents = 6;
   */
  arrCents: bigint;

  /**
   * Churn
   *
   * @generated from field: int32 churned_last_30_days = 7;
   */
  churnedLast30Days: number;

  /**
   * @generated from field: float churn_rate_percent = 8;
   */
  churnRatePercent: number;

  /**
   * Growth
   *
   * @generated from field: int32 new_subscribers_last_30_days = 9;
   */
  newSubscribersLast30Days: number;

  /**
   * @generated from field: float growth_rate_percent = 10;
   */
  growthRatePercent: number;

  /**
   * Time series for charts
   *
   * @generated from field: repeated guardianai.v1.infra.DailySubscriptionMetric daily_metrics = 11;
   */
  dailyMetrics: DailySubscriptionMetric[];
};

/**
 * ============================================
 * SUBSCRIPTION STATS (Admin Dashboard)
 * ============================================
 *
 * @generated from message guardianai.v1.infra.SubscriptionStats
 */
export type SubscriptionStatsJson = {
  /**
   * @generated from field: int32 total_subscribers = 1;
   */
  totalSubscribers?: number;

  /**
   * @generated from field: int32 pro_subscribers = 2;
   */
  proSubscribers?: number;

  /**
   * @generated from field: int32 enterprise_subscribers = 3;
   */
  enterpriseSubscribers?: number;

  /**
   * @generated from field: int32 active_trials = 4;
   */
  activeTrials?: number;

  /**
   * Revenue
   *
   * Monthly Recurring Revenue in cents
   *
   * @generated from field: int64 mrr_cents = 5;
   */
  mrrCents?: string;

  /**
   * Annual Recurring Revenue in cents
   *
   * @generated from field: int64 arr_cents = 6;
   */
  arrCents?: string;

  /**
   * Churn
   *
   * @generated from field: int32 churned_last_30_days = 7;
   */
  churnedLast30Days?: number;

  /**
   * @generated from field: float churn_rate_percent = 8;
   */
  churnRatePercent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Growth
   *
   * @generated from field: int32 new_subscribers_last_30_days = 9;
   */
  newSubscribersLast30Days?: number;

  /**
   * @generated from field: float growth_rate_percent = 10;
   */
  growthRatePercent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Time series for charts
   *
   * @generated from field: repeated guardianai.v1.infra.DailySubscriptionMetric daily_metrics = 11;
   */
  dailyMetrics?: DailySubscriptionMetricJson[];
};

/**
 * Describes the message guardianai.v1.infra.SubscriptionStats.
 * Use `create(SubscriptionStatsSchema)` to create a new message.
 */
export const SubscriptionStatsSchema: GenMessage<SubscriptionStats, {jsonType: SubscriptionStatsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 9);

/**
 * @generated from message guardianai.v1.infra.DailySubscriptionMetric
 */
export type DailySubscriptionMetric = Message<"guardianai.v1.infra.DailySubscriptionMetric"> & {
  /**
   * YYYY-MM-DD
   *
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: int32 new_subscribers = 2;
   */
  newSubscribers: number;

  /**
   * @generated from field: int32 churned = 3;
   */
  churned: number;

  /**
   * @generated from field: int64 revenue_cents = 4;
   */
  revenueCents: bigint;
};

/**
 * @generated from message guardianai.v1.infra.DailySubscriptionMetric
 */
export type DailySubscriptionMetricJson = {
  /**
   * YYYY-MM-DD
   *
   * @generated from field: string date = 1;
   */
  date?: string;

  /**
   * @generated from field: int32 new_subscribers = 2;
   */
  newSubscribers?: number;

  /**
   * @generated from field: int32 churned = 3;
   */
  churned?: number;

  /**
   * @generated from field: int64 revenue_cents = 4;
   */
  revenueCents?: string;
};

/**
 * Describes the message guardianai.v1.infra.DailySubscriptionMetric.
 * Use `create(DailySubscriptionMetricSchema)` to create a new message.
 */
export const DailySubscriptionMetricSchema: GenMessage<DailySubscriptionMetric, {jsonType: DailySubscriptionMetricJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 10);

/**
 * ============================================
 * PRICING MANAGEMENT
 * ============================================
 *
 * @generated from message guardianai.v1.infra.InfraPricing
 */
export type InfraPricing = Message<"guardianai.v1.infra.InfraPricing"> & {
  /**
   * 1000 = $10
   *
   * @generated from field: int64 pro_price_cents = 1;
   */
  proPriceCents: bigint;

  /**
   * 4900 = $49
   *
   * @generated from field: int64 enterprise_price_cents = 2;
   */
  enterprisePriceCents: bigint;

  /**
   * USD
   *
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * Stripe Price IDs (read-only, managed by system)
   *
   * @generated from field: string stripe_pro_price_id = 4;
   */
  stripeProPriceId: string;

  /**
   * @generated from field: string stripe_enterprise_price_id = 5;
   */
  stripeEnterprisePriceId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * ============================================
 * PRICING MANAGEMENT
 * ============================================
 *
 * @generated from message guardianai.v1.infra.InfraPricing
 */
export type InfraPricingJson = {
  /**
   * 1000 = $10
   *
   * @generated from field: int64 pro_price_cents = 1;
   */
  proPriceCents?: string;

  /**
   * 4900 = $49
   *
   * @generated from field: int64 enterprise_price_cents = 2;
   */
  enterprisePriceCents?: string;

  /**
   * USD
   *
   * @generated from field: string currency = 3;
   */
  currency?: string;

  /**
   * Stripe Price IDs (read-only, managed by system)
   *
   * @generated from field: string stripe_pro_price_id = 4;
   */
  stripeProPriceId?: string;

  /**
   * @generated from field: string stripe_enterprise_price_id = 5;
   */
  stripeEnterprisePriceId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.infra.InfraPricing.
 * Use `create(InfraPricingSchema)` to create a new message.
 */
export const InfraPricingSchema: GenMessage<InfraPricing, {jsonType: InfraPricingJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 11);

/**
 * @generated from message guardianai.v1.infra.UpdatePricingRequest
 */
export type UpdatePricingRequest = Message<"guardianai.v1.infra.UpdatePricingRequest"> & {
  /**
   * @generated from field: int64 pro_price_cents = 1;
   */
  proPriceCents: bigint;

  /**
   * @generated from field: int64 enterprise_price_cents = 2;
   */
  enterprisePriceCents: bigint;
};

/**
 * @generated from message guardianai.v1.infra.UpdatePricingRequest
 */
export type UpdatePricingRequestJson = {
  /**
   * @generated from field: int64 pro_price_cents = 1;
   */
  proPriceCents?: string;

  /**
   * @generated from field: int64 enterprise_price_cents = 2;
   */
  enterprisePriceCents?: string;
};

/**
 * Describes the message guardianai.v1.infra.UpdatePricingRequest.
 * Use `create(UpdatePricingRequestSchema)` to create a new message.
 */
export const UpdatePricingRequestSchema: GenMessage<UpdatePricingRequest, {jsonType: UpdatePricingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 12);

/**
 * ============================================
 * STRIPE CHECKOUT FOR INFRA
 * ============================================
 *
 * @generated from message guardianai.v1.infra.CreateInfraCheckoutRequest
 */
export type CreateInfraCheckoutRequest = Message<"guardianai.v1.infra.CreateInfraCheckoutRequest"> & {
  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 1;
   */
  tier: LicenseTier;

  /**
   * @generated from field: string customer_email = 2;
   */
  customerEmail: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * Frontend URL to redirect after success
   *
   * @generated from field: string success_url = 4;
   */
  successUrl: string;

  /**
   * Frontend URL to redirect on cancel
   *
   * @generated from field: string cancel_url = 5;
   */
  cancelUrl: string;
};

/**
 * ============================================
 * STRIPE CHECKOUT FOR INFRA
 * ============================================
 *
 * @generated from message guardianai.v1.infra.CreateInfraCheckoutRequest
 */
export type CreateInfraCheckoutRequestJson = {
  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 1;
   */
  tier?: LicenseTierJson;

  /**
   * @generated from field: string customer_email = 2;
   */
  customerEmail?: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName?: string;

  /**
   * Frontend URL to redirect after success
   *
   * @generated from field: string success_url = 4;
   */
  successUrl?: string;

  /**
   * Frontend URL to redirect on cancel
   *
   * @generated from field: string cancel_url = 5;
   */
  cancelUrl?: string;
};

/**
 * Describes the message guardianai.v1.infra.CreateInfraCheckoutRequest.
 * Use `create(CreateInfraCheckoutRequestSchema)` to create a new message.
 */
export const CreateInfraCheckoutRequestSchema: GenMessage<CreateInfraCheckoutRequest, {jsonType: CreateInfraCheckoutRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 13);

/**
 * @generated from message guardianai.v1.infra.InfraCheckoutSession
 */
export type InfraCheckoutSession = Message<"guardianai.v1.infra.InfraCheckoutSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string checkout_url = 2;
   */
  checkoutUrl: string;

  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 3;
   */
  tier: LicenseTier;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;
};

/**
 * @generated from message guardianai.v1.infra.InfraCheckoutSession
 */
export type InfraCheckoutSessionJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: string checkout_url = 2;
   */
  checkoutUrl?: string;

  /**
   * @generated from field: guardianai.v1.infra.LicenseTier tier = 3;
   */
  tier?: LicenseTierJson;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 5;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.infra.InfraCheckoutSession.
 * Use `create(InfraCheckoutSessionSchema)` to create a new message.
 */
export const InfraCheckoutSessionSchema: GenMessage<InfraCheckoutSession, {jsonType: InfraCheckoutSessionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 14);

/**
 * ============================================
 * SUBSCRIPTION EVENTS (for tracking/audit)
 * ============================================
 *
 * @generated from message guardianai.v1.infra.InfraSubscriptionEvent
 */
export type InfraSubscriptionEvent = Message<"guardianai.v1.infra.InfraSubscriptionEvent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string license_id = 2;
   */
  licenseId: string;

  /**
   * created, renewed, canceled, upgraded, downgraded
   *
   * @generated from field: string event_type = 3;
   */
  eventType: string;

  /**
   * @generated from field: string stripe_event_id = 4;
   */
  stripeEventId: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * ============================================
 * SUBSCRIPTION EVENTS (for tracking/audit)
 * ============================================
 *
 * @generated from message guardianai.v1.infra.InfraSubscriptionEvent
 */
export type InfraSubscriptionEventJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string license_id = 2;
   */
  licenseId?: string;

  /**
   * created, renewed, canceled, upgraded, downgraded
   *
   * @generated from field: string event_type = 3;
   */
  eventType?: string;

  /**
   * @generated from field: string stripe_event_id = 4;
   */
  stripeEventId?: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.infra.InfraSubscriptionEvent.
 * Use `create(InfraSubscriptionEventSchema)` to create a new message.
 */
export const InfraSubscriptionEventSchema: GenMessage<InfraSubscriptionEvent, {jsonType: InfraSubscriptionEventJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_infra_infra_license, 15);

/**
 * ============================================
 * LICENSE TIER ENUM
 * ============================================
 *
 * @generated from enum guardianai.v1.infra.LicenseTier
 */
export enum LicenseTier {
  /**
   * @generated from enum value: LICENSE_TIER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * $10/month - 5 services, 2 environments
   *
   * @generated from enum value: LICENSE_TIER_PRO = 1;
   */
  PRO = 1,

  /**
   * $49/month - Unlimited services, HA, priority support
   *
   * @generated from enum value: LICENSE_TIER_ENTERPRISE = 2;
   */
  ENTERPRISE = 2,
}

/**
 * ============================================
 * LICENSE TIER ENUM
 * ============================================
 *
 * @generated from enum guardianai.v1.infra.LicenseTier
 */
export type LicenseTierJson = "LICENSE_TIER_UNSPECIFIED" | "LICENSE_TIER_PRO" | "LICENSE_TIER_ENTERPRISE";

/**
 * Describes the enum guardianai.v1.infra.LicenseTier.
 */
export const LicenseTierSchema: GenEnum<LicenseTier, LicenseTierJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_infra_infra_license, 0);

/**
 * ============================================
 * INFRA LICENSE SERVICE
 * License generation, validation, and management
 * ============================================
 *
 * @generated from service guardianai.v1.infra.InfraLicenseService
 */
export const InfraLicenseService: GenService<{
  /**
   * License CRUD
   *
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.GenerateLicense
   */
  generateLicense: {
    methodKind: "unary";
    input: typeof GenerateLicenseRequestSchema;
    output: typeof LicenseResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.ValidateLicense
   */
  validateLicense: {
    methodKind: "unary";
    input: typeof ValidateLicenseRequestSchema;
    output: typeof ValidationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.GetLicense
   */
  getLicense: {
    methodKind: "unary";
    input: typeof GetLicenseRequestSchema;
    output: typeof InfraLicenseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.ListLicenses
   */
  listLicenses: {
    methodKind: "unary";
    input: typeof ListLicensesRequestSchema;
    output: typeof ListLicensesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.RevokeLicense
   */
  revokeLicense: {
    methodKind: "unary";
    input: typeof RevokeLicenseRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Subscription Stats (Admin Dashboard)
   *
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.GetSubscriptionStats
   */
  getSubscriptionStats: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SubscriptionStatsSchema;
  },
  /**
   * Pricing Management
   *
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.GetPricing
   */
  getPricing: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof InfraPricingSchema;
  },
  /**
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.UpdatePricing
   */
  updatePricing: {
    methodKind: "unary";
    input: typeof UpdatePricingRequestSchema;
    output: typeof InfraPricingSchema;
  },
  /**
   * Stripe Checkout for Infra subscriptions
   *
   * @generated from rpc guardianai.v1.infra.InfraLicenseService.CreateInfraCheckout
   */
  createInfraCheckout: {
    methodKind: "unary";
    input: typeof CreateInfraCheckoutRequestSchema;
    output: typeof InfraCheckoutSessionSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_infra_infra_license, 0);

